module.exports = __webpack_public_path__ + "static/img/ist_logo.b2eeb5d.png";


//////////////////
// WEBPACK FOOTER
// ./static/partner-logos/ist_logo.png
// module id = DYc6
// module chunks = 0